// src/hooks/useUserStatusValidator.js
import { useEffect, useRef } from 'react';
import requestGenerico from '../componentes/http/HttpCliente';

export function useUserStatusValidator(intervalMs = 60000) { // Por defecto, comprobar cada minuto
  // Usar useRef para guardar el timer y evitar múltiples instancias
  const timerRef = useRef(null);

  useEffect(() => {
    // Función para validar el estado del usuario
    const validateUserStatus = async () => {
      try {
        await requestGenerico.validarEstadoUsuario();
      } catch (error) {
        // Si hay un error, el interceptor ya se encargará
        console.log('Error validando usuario:', error);
      }
    };

    // Validar al inicio
    validateUserStatus();
    
    // Establecer comprobaciones periódicas
    timerRef.current = setInterval(validateUserStatus, intervalMs);
    
    // Limpiar el intervalo al desmontar
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [intervalMs]);
}